module.exports = __webpack_public_path__ + "img/levelup-manager.a776a8b1.svg";